const InfoBox = (props) => {
    const InfoBoxClasses = ['InfoBox'];

    if(props.absolute){
        InfoBoxClasses.push('absolute');
    }

    if(props.hidden){
        InfoBoxClasses.push('hidden');
    }

    return (<div className={InfoBoxClasses.join(' ')}>
        <div className="d-flex">
            <div className="me-4"><svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 0C6.03 0 0 6.03 0 13.5C0 20.97 6.03 27 13.5 27C20.97 27 27 20.97 27 13.5C27 6.03 20.97 0 13.5 0ZM15 19.77C15 20.5801 14.3101 21.2401 13.5 21.2401C12.6899 21.2401 12 20.5801 12 19.77V12.09C12 11.2799 12.6899 10.6199 13.5 10.6199C14.3101 10.6199 15 11.2799 15 12.09V19.77ZM13.5299 8.7C12.7199 8.7 12.0599 8.04 12.0599 7.22995C12.0599 6.41989 12.7199 5.75989 13.5299 5.75989C14.34 5.75989 15 6.41989 15 7.22995C15 8.04 14.34 8.7 13.5299 8.7Z" fill="#5CC244"/></svg></div>
            <div>{props.children}</div>
        </div>
    </div>);
}

export default InfoBox;